var _path, _path2, _path3, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "video",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.786,
    height: 47.535,
    viewBox: "0 0 48.786 47.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_215409",
    "data-name": "Path 215409",
    d: "M4.052,345.273H.625a.625.625,0,1,1,0-1.251H4.052a.625.625,0,1,1,0,1.251Z",
    transform: "translate(0 -308.786)",
    fill: "#00057d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215410",
    "data-name": "Path 215410",
    d: "M75.4,6H37.876A1.879,1.879,0,0,0,36,7.876V34a1.879,1.879,0,0,0,1.876,1.876h.558a5.41,5.41,0,0,1,1.057-2.163h-.469a.625.625,0,0,1-.625-.625V8.789a.625.625,0,0,1,.625-.625H74.257a.625.625,0,0,1,.625.625v24.3a.625.625,0,0,1-.625.625h-.486a5.41,5.41,0,0,1,1.057,2.163H75.4A1.879,1.879,0,0,0,77.28,34V7.876A1.879,1.879,0,0,0,75.4,6Z",
    transform: "translate(-32.247 -6)",
    fill: "#00057d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215411",
    "data-name": "Path 215411",
    d: "M427.177,345.273H423.75a.625.625,0,0,1,0-1.251h3.427a.625.625,0,0,1,0,1.251Z",
    transform: "translate(-379.017 -308.786)",
    fill: "#00057d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98092",
    "data-name": "Group 98092",
    transform: "translate(7.401 3.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215412",
    "data-name": "Path 215412",
    d: "M223.115,110.135v4.833l3.9-2.416Z",
    transform: "translate(-207.258 -102.694)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215413",
    "data-name": "Path 215413",
    d: "M182.046,87.407A6.046,6.046,0,1,0,176,81.361,6.053,6.053,0,0,0,182.046,87.407Zm-2.386-9.586a.631.631,0,0,1,.955-.532l5.711,3.54a.631.631,0,0,1,0,1.063l-5.711,3.54a.631.631,0,0,1-.955-.532Z",
    transform: "translate(-165.055 -71.504)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215414",
    "data-name": "Path 215414",
    d: "M71,38.752V61.8h1.264a5.55,5.55,0,0,1,8.3,3.414H82.6a5.544,5.544,0,0,1,10.775,0H95.4a5.55,5.55,0,0,1,8.3-3.414h1.281V38.752Zm16.992,2.561a7.3,7.3,0,1,1-7.3,7.3A7.305,7.305,0,0,1,87.992,41.313Zm10.32,17.721H82.961v.435a.625.625,0,0,1-1.251,0v-.435H77.672a.625.625,0,0,1,0-1.251H81.71v-.435a.625.625,0,0,1,1.251,0v.435H98.312a.625.625,0,1,1,0,1.251Z",
    transform: "translate(-71 -38.752)",
    fill: "#00057d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98096",
    "data-name": "Group 98096",
    transform: "translate(7.295 26.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98093",
    "data-name": "Group 98093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215415",
    "data-name": "Path 215415",
    d: "M74.259,264a4.221,4.221,0,1,0,4.28,4.22A4.255,4.255,0,0,0,74.259,264Z",
    transform: "translate(-69.979 -264)",
    fill: "#00057d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98094",
    "data-name": "Group 98094",
    transform: "translate(25.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215416",
    "data-name": "Path 215416",
    d: "M320.021,264a4.221,4.221,0,1,0,4.28,4.22A4.255,4.255,0,0,0,320.021,264Z",
    transform: "translate(-315.741 -264)",
    fill: "#00057d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98095",
    "data-name": "Group 98095",
    transform: "translate(12.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215417",
    "data-name": "Path 215417",
    d: "M197.223,264a4.221,4.221,0,1,0,4.28,4.22A4.255,4.255,0,0,0,197.223,264Z",
    transform: "translate(-192.943 -264)",
    fill: "#00057d"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98097",
    "data-name": "Group 98097",
    transform: "translate(0 36.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215418",
    "data-name": "Path 215418",
    d: "M45.033,360.832H42.646a5.781,5.781,0,0,0-11.234,1.922v3.916H30.175v-3.916a5.782,5.782,0,1,0-11.564,0v3.916H17.356v-3.916a5.781,5.781,0,0,0-11.234-1.922H3.753a.625.625,0,0,0,0,1.251h2.08a5.8,5.8,0,0,0-.04.671v3.916H.625a.625.625,0,1,0,0,1.251H43.47a.625.625,0,1,0,0-1.251h-.495v-3.916a5.8,5.8,0,0,0-.04-.671h2.1a.625.625,0,0,0,0-1.251Z",
    transform: "translate(0 -356.972)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215419",
    "data-name": "Path 215419",
    d: "M440.511,450h-1.875a.625.625,0,1,0,0,1.251h1.875a.625.625,0,1,0,0-1.251Z",
    transform: "translate(-392.351 -440.302)",
    fill: "#00057d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats4);
export default __webpack_public_path__ + "static/media/stats4.e08d18cb867fa767ed1786db6f3b3ffb.svg";
export { ForwardRef as ReactComponent };